import React from 'react';
import { EditorialForm } from './editorialForm';
import { Field, Fields, Hint, Note, Panel } from './editorialStyles';
import RichTextEditor from './RichTextEditor';

interface Props {
  form: EditorialForm;
  onChange: (field: keyof EditorialForm, value: string) => void;
  published: boolean;
  disabled: boolean;
}

const EditorialFields: React.FC<Props> = ({ form, onChange, published, disabled }) => <>
  <Panel aria-labelledby="article-title">
    <h2 id="article-title">Artigo</h2>
    <Field>Título
      <input required minLength={3} maxLength={250} value={form.title} disabled={disabled} onChange={event => onChange('title', event.target.value)} />
    </Field>
    <Field>Endereço do artigo
      <input required maxLength={160} value={form.slug} pattern="[a-z0-9]+(?:-[a-z0-9]+)*" disabled={disabled || published}
        placeholder="como-escolher-um-bairro-em-rio-preto" onChange={event => onChange('slug', event.target.value)} />
      <small>/blog/{form.slug || 'endereco-do-artigo'}{published ? ' · O endereço é mantido após a primeira publicação.' : ' · Use letras minúsculas, números e hífens.'}</small>
    </Field>
    <Field>Resumo para o blog
      <textarea rows={3} maxLength={1000} value={form.excerpt} disabled={disabled} onChange={event => onChange('excerpt', event.target.value)} />
    </Field>
    <RichTextEditor value={form.content} disabled={disabled} onChange={value => onChange('content', value)} />
  </Panel>
  <Panel aria-labelledby="publication-heading">
    <h2 id="publication-heading">Programação</h2>
    <Field>Data e hora de publicação (Brasília)
      <input type="datetime-local" aria-label="Data e hora de publicação (Brasília)" value={form.scheduled_at} disabled={disabled} onChange={event => onChange('scheduled_at', event.target.value)} />
      <small>Horário de Brasília · America/Sao_Paulo (UTC−3), mesmo que você esteja em outro fuso.</small>
    </Field>
    <Note>Sem aprovação, não será publicado. A data reserva o horário; um administrador precisa aprovar a versão salva antes desse horário.</Note>
    {published && <Hint>Ao editar, a versão já publicada continua no site até uma nova versão ser aprovada e publicada.</Hint>}
  </Panel>
  <Panel aria-labelledby="author-heading">
    <h2 id="author-heading">Quem assina</h2>
    <Fields>
      <Field>Nome do autor
        <input maxLength={160} value={form.author_name} disabled={disabled} onChange={event => onChange('author_name', event.target.value)} />
      </Field>
      <Field>Página do autor (opcional)
        <input type="text" inputMode="url" maxLength={2048} placeholder="https://... ou /sobre" value={form.author_url} disabled={disabled} onChange={event => onChange('author_url', event.target.value)} />
      </Field>
    </Fields>
    <Field>Apresentação do autor
      <textarea rows={2} maxLength={2000} value={form.author_bio} disabled={disabled} onChange={event => onChange('author_bio', event.target.value)} />
      <small>Informe a experiência real de quem revisou e assina o conteúdo.</small>
    </Field>
  </Panel>
  <Panel aria-labelledby="search-heading">
    <h2 id="search-heading">Imagem e busca</h2>
    <Field>Descrição para os buscadores
      <textarea rows={2} maxLength={320} value={form.meta_description} disabled={disabled} onChange={event => onChange('meta_description', event.target.value)} />
      <small>{form.meta_description.length} caracteres · Resuma o que o leitor vai encontrar. Cerca de 150–160 caracteres costuma ser suficiente.</small>
    </Field>
    <Field>Endereço da imagem de capa (opcional)
      <input type="text" inputMode="url" maxLength={2048} placeholder="https://... ou /images/..." value={form.featured_image} disabled={disabled} onChange={event => onChange('featured_image', event.target.value)} />
    </Field>
    <Field>Descrição da imagem
      <input maxLength={300} value={form.featured_image_alt} disabled={disabled} onChange={event => onChange('featured_image_alt', event.target.value)} />
      <small>Descreva o que aparece na imagem para pessoas que usam leitores de tela.</small>
    </Field>
  </Panel>
</>;

export default EditorialFields;
